import {
  BusinessAccountsProTermsOfUseModel,
  BusinessAccountsTermsOfUseDto,
  BusinessAccountsTermsOfUseResp,
} from '../types/terms-content'

export const transformBusinessAccountsTermsOfUseDto = (
  dto: BusinessAccountsTermsOfUseDto,
): BusinessAccountsProTermsOfUseModel => ({
  title: dto.title,
  body: dto.body,
  terms_updates: dto.terms_updates,
})

export const transformBusinessAccountsTermsOfUseResponse = (
  response: BusinessAccountsTermsOfUseResp,
) => transformBusinessAccountsTermsOfUseDto(response)
